import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, URLSearchParams } from "@angular/http";

import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

import { config } from "app/shared/smartadmin.config";
import { 
    OrdenServicioComentarioDto, 
    AgregarComentarioRequest, 
    ModificarComentarioRequest 
} from "../model/interfaces/comentarios.interface";

@Injectable()
export class OrdenServicioComentariosService {
  private readonly url = config.API_DATA_URL + "/OrdenServicioComentarios";

  constructor(private http: Http) {}

  obtener(
    idOrdenServicio: number,
    claveProceso: string,
  ): Observable<OrdenServicioComentarioDto[]> {
    const params = new URLSearchParams();

    params.set("idOrdenServicio", idOrdenServicio.toString());

    params.set("claveProceso", claveProceso);

    const options = new RequestOptions({
      search: params,
    });

    return this.http
      .get(this.url, options)
      .map((response) => {
        const datos = response.json();

        return datos.map((item) => {
          return {
            idOrdenServicioComentario: item.idOrdenServicioComentario,

            idOrdenServicio: item.idOrdenServicio,

            claveProceso: item.claveProceso,

            idEmpleado: item.idEmpleado,

            empleado: item.empleado,

            comentario: item.comentario,

            fechaRegistro: new Date(item.fechaRegistro),
          };
        });
      })
      .catch(this.handleError);
  }

  agregar(
    idOrdenServicio: number,
    claveProceso: string,
    idEmpleado: number,
    comentario: string,
  ): Observable<any> {
    const request: AgregarComentarioRequest = {
      idOrdenServicio: idOrdenServicio,
      claveProceso: claveProceso,
      idEmpleado: idEmpleado,
      comentario: comentario,
    };

    return this.http
      .post(this.url, JSON.stringify(request), this.getRequestOptions())
      .map((response) => response.json())
      .catch(this.handleError);
  }

  modificar(
    idOrdenServicioComentario: number,
    idEmpleado: number,
    comentario: string,
  ): Observable<any> {
    const request: ModificarComentarioRequest = {
      idEmpleado: idEmpleado,
      comentario: comentario,
    };

    return this.http
      .put(
        this.url + "/" + idOrdenServicioComentario,
        JSON.stringify(request),
        this.getRequestOptions(),
      )
      .map((response) => response.json())
      .catch(this.handleError);
  }

  eliminar(
    idOrdenServicioComentario: number,
    idEmpleado: number,
  ): Observable<any> {
    const params = new URLSearchParams();

    params.set("idEmpleado", idEmpleado.toString());

    const options = new RequestOptions({
      search: params,
    });

    return this.http
      .delete(this.url + "/" + idOrdenServicioComentario, options)
      .map((response) => response.json())
      .catch(this.handleError);
  }

  private getRequestOptions(): RequestOptions {
    const headers = new Headers({
      "Content-Type": "application/json",
    });

    return new RequestOptions({
      headers: headers,
    });
  }

  private handleError(error: any): Observable<any> {
    let mensaje = "Ocurrió un error al procesar la solicitud.";

    try {
      const body = error.json();

      if (body && body.mensaje) {
        mensaje = body.mensaje;
      }
    } catch (e) {
      // Conservamos mensaje genérico.
    }

    return Observable.throw(mensaje);
  }
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/comentarios-api.service.ts